import BaseRoute from 'seshy/routes/base';

export default class TeamsRoute extends BaseRoute {}
